function generateSecretKey() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = 'whk_';
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// Returns extra initial data for a node type at creation time.
export function getInitialNodeData(nodeType) {
  if (nodeType === 'trigger_webhook') {
    return { secretKey: generateSecretKey() };
  }
  return {};
}
